module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customerList"
  }, [_c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearchBox),
      expression: "showSearchBox"
    }],
    ref: "searchForm",
    attrs: {
      "inline": true,
      "model": _vm.searchForm,
      "rules": _vm.searchRules
    }
  }, [_c('h1', [_vm._v("Customer List")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "searchType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Please Select"
    },
    model: {
      value: (_vm.searchForm.searchType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "searchType", $$v)
      },
      expression: "searchForm.searchType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Name",
      "value": "cus_name"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Email Address",
      "value": "cus_email"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "searchQuery"
    }
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "maxlength": "30"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onClickSearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.searchForm.searchQuery),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "searchQuery", $$v)
      },
      expression: "searchForm.searchQuery"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search",
      "loading": _vm.searching
    },
    on: {
      "click": function($event) {
        return _vm.onClickSearch()
      }
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": _vm.onClickAdd
    }
  }, [_vm._v("Add Customer")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCustomerData || _vm.searching),
      expression: "showCustomerData || searching"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.searching),
      expression: "searching"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.customerData,
      "empty-text": "No Record Found",
      "cell-style": {
        textAlign: 'center'
      },
      "border": "",
      "header-cell-style": {
        textAlign: 'center',
        background: '#E5E7E9'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "prop": "name",
      "label": "Customer Name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "label": "Customer Email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addr",
      "label": "Address"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tel",
      "label": "Tel."
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "desc",
      "label": "Description"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "Operation",
      "empty-text": "No Record Found",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button-group', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.showCustomerData),
            expression: "showCustomerData"
          }]
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.onClickModify(scope.row)
            }
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "plain": "",
            "icon": "el-icon-delete"
          },
          on: {
            "click": function($event) {
              return _vm.onClickDelete(scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCustomerData),
      expression: "showCustomerData"
    }],
    attrs: {
      "current-page": _vm.curPage,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.numOfData
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-050d9e36","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerList.vue
// module id = iV5h
// module chunks = 1